import {ETariffDetailStatus, ETariffDetailType, ETariffStatus} from './definitions';

export default {
  addTariff: 'Add tariff',
  searchPlaceholder: 'Quick search by tariff name',
  th: {
    tariffId: 'Tariff ID',
    name: 'Tariff name',
    channel: 'Channel',
    documentType: 'Document type',
    status: 'Status',
    reseller: 'Reseller',
  },
  filters: {
    countries: 'Country',
    detailLabels: 'Condition label',
    detailTypes: 'Condition type',
    pricingDetailLabels: 'Pricing label',
    pricingDetailTypes: 'Pricing type',
    currencies: 'Currency',
  },
  detailType: {
    [ETariffDetailType.LICENSE]: 'License',
    [ETariffDetailType.OPERATOR]: 'Operator',
    [ETariffDetailType.REGION]: 'Region',
  },
  tariffStatus: {
    [ETariffStatus.ACTIVE]: 'ACTIVE',
    [ETariffStatus.ARCHIVED]: 'ARCHIVED',
    [ETariffStatus.CLOSED]: 'CLOSED',
  },
  detailStatus: {
    [ETariffDetailStatus.ACTIVE]: 'Active',
    [ETariffDetailStatus.PLANNED]: 'Planned',
  },
  tariffCard: {
    id: 'ID',
    reseller: 'Reseller',
    documentType: 'Document type',
    label: 'Label',
    tariff: 'Tariff',
    tariffDetails: 'Tariff conditions',
    version: 'Version',
    detailType: 'Condition type',
    detailPricingType: 'Pricing type',
    activeFrom: 'Active from',
    activeTo: 'Active to',
    country: 'Country',
    currency: 'Currency',
    jsonData: 'Properties, JSON',
    addTariffDetail: 'Add condition',
    uploadTariffFile: 'Upload tariff file',
    tariffPricingDetails: 'Pricing',
    addTariffPricingDetail: 'Add pricing',
    search: 'Filters',
    plannedChanges: 'A change is planned',
    vatHint: 'All prices are indicated without VAT',
    cancelPlannedChanges: 'Cancel changes',
    changeTariff: 'Change the conditions',
    cancelPlannedChangesSuccess: 'All changes have been successfully canceled',
    cancelPlannedChangesConfirm:
      'Are you sure you want to delete all scheduled changes to the tariff without the possibility of recovery?',
    smsCommon: '[en] Запрет управления операторами в Анкете',
  },
  detailStatusHint:
    'The "Planned" section contains conditions or pricing for which there are no active versions.',
  actions: {
    showChanges: 'Show changes',
    cancelChanges: 'Cancel changes',
    edit: 'Edit',
    history: 'Show history',
  },
  addTariffModal: {
    title: 'Create tariff',
    titleEdit: 'Edit tariff',
    name: 'Tariff label',
    channel: 'Channel',
    reseller: 'Reseller',
    documentType: 'Document type',
    saveContinue: 'Save and continue',
    smsCommon: '[en] Запретить управление операторами в Анкете',
  },
  editTariffDetailForm: {
    title: 'Add tariff condition',
    titleEdit: 'Edit tariff condition',
    label: 'Condition label',
    country: 'Country',
    currency: 'Currency',
    previousActiveFrom: 'Previous active from date and time',
    activeFrom: 'Active from date and time',
    activeFromHint:
      'Your current time zone does not match the time zone of Moscow. Select the time and date of the tariff activation according to the Moscow time zone. \nThe information about the fare will be displayed in your time zone.',
    data: 'Condition properties',
    dataHint: 'Fill in the condition properties in JSON format',
    comment: 'Comment on the change',
    commentHint:
      'For example, the number of the request to the support, according to which these changes are being made',
  },
  editTariffPricingDetailForm: {
    title: 'Add pricing',
    titleEdit: 'Edit pricing',
    label: 'Pricing label',
    previousActiveFrom: 'Previous active from date and time',
    activeFrom: 'Active from date and time',
    activeFromHint:
      'Your current time zone does not match the time zone of Moscow. Select the time and date of the tariff activation according to the Moscow time zone. \nThe information about the fare will be displayed in your time zone.',
    data: 'Pricing properties',
    dataHint: 'Fill in the pricing properties in JSON format',
    vatHint: 'All prices must be indicated without VAT',
    comment: 'Comment on the change',
    commentHint:
      'For example, the number of the request to the support, according to which these changes are being made',
  },
  cancelChangesModal: {
    title: 'Cancel planned changes?',
    subtitle: 'The changes planned earlier will not take effect within the specified period.',
    submitButton: 'Cancel changes',
    successNotification: 'Planned changes have been successfully canceled',
  },
  plannedDetailModalTitle: 'Planned changes',
  archivedDetailsModal: {
    detailsTitle: 'Archived details',
    pricingDetailsTitle: 'Archived pricing details',
  },
  copyTariffModal: {
    title: 'Copy tariff',
    name: 'Copied tariff:',
    channel: 'Channel:',
    newName: 'New tariff label',
    reseller: 'Reseller',
    documentType: 'Document type',
    activeFrom: 'Active from date and time',
    activeFromHint:
      'Your current time zone does not match the time zone of Moscow. Select the time and date of the tariff activation according to the Moscow time zone. \nThe information about the fare will be displayed in your time zone.',
  },
  noData: 'No data',
};
